import { createContext } from "react";
import type { UseFormReturn } from "react-hook-form";

import type { AdminStructureDetail } from "../../api/structures/structures.types";
import type { AdminStructureGeneralDataForm } from "../../schemas";

export const STRUCTURE_GENERAL_DATA_FORM_ID = "admin-structure-general-data-form";

export type AdminStructureGeneralDataFormContextValue = {
  complexId: string;
  structureId: string;
  detail: AdminStructureDetail;
  canWrite: boolean;
  onSaved: (detail: AdminStructureDetail) => void;
  typeLocked: boolean;
  embedForm: boolean;
  isSaving: boolean;
  isUploadingOrthophoto: boolean;
  pendingOrthophotoFile: File | null;
  setPendingOrthophotoFile: (file: File | null) => void;
  uploadPendingOrthophoto: () => Promise<void>;
  form: UseFormReturn<AdminStructureGeneralDataForm>;
  onSubmit: (data: AdminStructureGeneralDataForm) => Promise<void>;
  onInvalidSubmit: () => void;
};

export const AdminStructureGeneralDataFormContext =
  createContext<AdminStructureGeneralDataFormContextValue | null>(null);
